/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q, page = 1, limit }) {
    return axios.get(this.url, {
      params: {
        q,
        page,
        limit,
      },
    });
  }

  contacts({ q, page = 1, limit }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
        page,
        limit,
      },
    });
  }

  conversations({ q, page = 1, limit }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
        page,
        limit,
      },
    });
  }

  messages({ q, page = 1, limit }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
        page,
        limit,
      },
    });
  }
}

export default new SearchAPI();
